import { useApiDefaults } from "hooks/useApiDefaults";
import axios from 'config/axios';
import { useQuery } from '@tanstack/react-query';
import { ReactQueryKeys } from 'config/constant';

export const useGetCouponDetails = (digital_coupon_id) => {
  const apiDefaults = useApiDefaults();
  
  const fetchCouponDetails = async () => {
    const body = {
      RSAClientId: apiDefaults.RSAClientId,
      ClientStoreId: apiDefaults.ClientStoreId,
      offer_id: digital_coupon_id,
      user_token: apiDefaults.user_token,
    };
    
    const response = await axios.post('/AogGetCouponsDetails', body);
    return response?.data?.data || {}
  };

  const { data, isLoading, error } = useQuery({
    queryKey: [ReactQueryKeys.COUPON_DETAILS, digital_coupon_id],
    queryFn: fetchCouponDetails,
    enabled: Boolean(digital_coupon_id && digital_coupon_id !== "0"),
  });

  return {
    data,
    isLoading,
    error,
  };
};